import { DraggedSingleData } from "../../../components/ui/DragToolsUI";
import { HudActions, HudNPCType } from "../../../components/ui/hud/HUDUI";
import { SBARUIConfig } from "../../../components/ui/SBARUI";
import BaseScenarioPart from "../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../misc/constants";
import { getNextPartId } from "../../../misc/tools";
import { DaarcBaseScenario } from "../../DaarcBaseScenario";
import { BaseGeneralConfig, GeneralPartConfig } from "../general-scenario-stuff";
import { GeneralStepCollection } from "../GeneralStepCollection";
import GeneralNeutralStatePart1 from "./parts/GeneralNeutralStatePart1";
import GeneralNeutralStatePart2 from "./parts/GeneralNeutralStatePart2";
import GeneralNeutralStatePart3 from "./parts/GeneralNeutralStatePart3";
import GeneralNeutralStatePart4 from "./parts/GeneralNeutralStatePart4";
import GeneralNeutralStatePart5 from "./parts/GeneralNeutralStatePart5";
import GeneralNeutralStatePart6 from "./parts/GeneralNeutralStatePart6";
import GeneralNeutralStatePart7 from "./parts/GeneralNeutralStatePart7";
import GeneralNeutralStatePart8 from "./parts/GeneralNeutralStatePart8";
var vortexCalled = false;
var suctionSet = false;
export default class GeneralNeutralStateMain extends GeneralStepCollection {
	private _parts: BaseScenarioPart<DaarcBaseScenario>[] = [];
	public toolsMessageTestScenario = 'You must induce apnea before attempting a procedure.'
	public testScenarioStartReached = false; //reached the start of where the user can do almost anything
	private _partId1 = getNextPartId();
	private _partId2 = getNextPartId();
	private _partId3 = getNextPartId();
	private _partId4 = getNextPartId();
	private _partId5 = getNextPartId();
	private _partId6 = getNextPartId();
	private _partId7 = getNextPartId();
	private _partId8 = getNextPartId();
	public onHudActionClicked(actionType: HudActions, personIconDown?: string, title?: string): boolean {
		switch(actionType) {
			case HudActions.RepeatSbarInformation:
				this.config.scenario.uiWrapper.displaySBAR(this.config.getSbarConfig());
				return true;
			case HudActions.VortexAid:
				this.config.scenario.uiWrapper.displayVortexJobAidUI({
					onCloseClicked: () => {}
				});
				return true;
			case HudActions.CallForVortex:
				vortexCalled = true;
				return false; //let part continue its logic while we implement scenario stuff here
		}

		if((this.config.isTestScenario && this.testScenarioStartReached) || 
								(this.config.isEmanuelMcKenzie && suctionSet)) {
			switch(actionType) {
				case HudActions.SetupSuction:
					(this.parts[2] as GeneralNeutralStatePart3).setUpSuction();
					return true;
				case HudActions.AdjustBedHeight:
					(this.parts[3] as GeneralNeutralStatePart4).adjustBedHeight(title);
					return true;
				case HudActions.AssessAirway:
					(this.parts[4] as GeneralNeutralStatePart5).showAssessAirway();
					return true;
				case HudActions.CallForFiberopticLaryngoscope:
					(this.parts[5] as GeneralNeutralStatePart6).laryngoscope(title);
					return true;
				case HudActions.PreOxygenatePatient:
					(this.parts[6] as GeneralNeutralStatePart7).preOxygenate();
					return true;
				case HudActions.AdministerMedications:
					(this.parts[7] as GeneralNeutralStatePart8).showUI(personIconDown, title);
					return true;
			}
		}

		if(this.config.isEmanuelMcKenzie && !suctionSet) {
			switch(actionType) {
				case HudActions.SetupSuction:
					suctionSet = true;
					return false;
			}
		}
		return false;
	}
	public get parts() {
		return this._parts;
	}
	constructor(public config: GeneralNeutralStateMainConfig) {
		super();
		var context = this;
		context._parts.push(new GeneralNeutralStatePart1(this, config.scenario, () => {
			context.goToStep2()
		}, context._partId1, config));

		context._parts.push(new GeneralNeutralStatePart2(this, config.scenario, () => {
			context.goToStep3()
			if(config.isEmanuelMcKenzie) {
				context.config.onDone();
			}
		}, context._partId2, config));

		context._parts.push(new GeneralNeutralStatePart3(this, config.scenario, () => {
			if(config.isEmanuelMcKenzie) {
				context.goToStep5()
			} else {
				context.goToStep4()
			}
		}, context._partId3, config));

		context._parts.push(new GeneralNeutralStatePart4(this, config.scenario, () => {
			context.goToStep5()
		}, context._partId4, config));

		context._parts.push(new GeneralNeutralStatePart5(this, config.scenario, () => {
			context.goToStep6()
		}, context._partId5, config));

		context._parts.push(new GeneralNeutralStatePart6(this, config.scenario, () => {
			context.goToStep7()
		}, context._partId6, config));

		context._parts.push(new GeneralNeutralStatePart7(this, config.scenario, () => {
			context.goToStep8()
		}, context._partId7, config));

		context._parts.push(new GeneralNeutralStatePart8(this, config.scenario, () => {
			if(!config.isEmanuelMcKenzie) {
				context.config.onDone();
			}
		}, context._partId8, config));
	}

	public start() {
		this.goToStep1();
	}

	goToStep1() {
		this.config.scenario.loadPart(this._partId1);
	}

	goToStep2() {
		this.config.scenario.loadPart(this._partId2);
	}

	goToStep3() {
		this.config.scenario.loadPart(this._partId3);
	}

	goToStep4() {
		this.config.scenario.loadPart(this._partId4);
	}

	goToStep5() {
		this.config.scenario.loadPart(this._partId5);
	}

	goToStep6() {
		this.config.scenario.loadPart(this._partId6);
	}

	goToStep7() {
		this.config.scenario.loadPart(this._partId7);
	}

	goToStep8() {
		this.config.scenario.loadPart(this._partId8);
	}
}

export interface GeneralNeutralStateMainConfig extends BaseGeneralConfig {
	scenario: DaarcBaseScenario;
	isEmanuelMcKenzie?: boolean;
	disabledNPCs?: HudNPCType[];
	disabledActions?: HudActions[];
	getSbarConfig: () => SBARUIConfig;
	onDone: () => void;
	part1Config?: GeneralNeutralStatePart1Config;
	part2Config?: GeneralNeutralStatePart2Config;
	part3Config?: GeneralNeutralStatePart3Config;
	part4Config?: GeneralNeutralStatePart4Config;
	part5Config?: GeneralNeutralStatePart5Config;
	part6Config?: GeneralNeutralStatePart6Config;
	part7Config?: GeneralNeutralStatePart7Config;
	part8Config?: GeneralNeutralStatePart8Config;
}

export interface GeneralNeutralStatePart1Config extends GeneralPartConfig {
	onCalledForVortex?: () => void;
	onCalledForOORam?: () => void;
	onOORamCalledForAnythingElse?: () => void;
	onCalledForAnythingElse?: () => void;
	hudIdleVideoChapter: () => string;
	isCric?: boolean; //will used only if in lite version
}

export interface GeneralNeutralStatePart2Config extends GeneralPartConfig {
	onToolsOrganized?: () => void;
	onTeamDebriefed?: () => void;
	onTeamNotDebriefed?: () => void;
	toolsToChooseFrom: DraggedSingleData[]; 
}

export interface GeneralNeutralStatePart3Config extends GeneralPartConfig {
	onSuctionSet?: () => void;
	onSettingUpAnythingElse?: () => void;
	waitForSuctionVideoChapter: () => string;
}

export interface GeneralNeutralStatePart4Config extends GeneralPartConfig {
	onAdjustedBedHeight?: () => void;
	onSettingUpAnythingElse?: () => void;
	waitForAdjustBedHeightVideoChapter: () => string;
}

export interface GeneralNeutralStatePart5Config extends GeneralPartConfig {
	onAssessmentFinied?: () => void;
	liftChinVideoChapter: () => string;
	chinToChestVideoChapter: () => string;
	examineNeckVideoChapter: () => string;
	realTeethVideoChapter: () => string;
	stickOutTongueVideoChapter: () => string;
}

export interface GeneralNeutralStatePart6Config extends GeneralPartConfig {
	onSetupFiberOptic?: () => void;
	onSettingUpAnythingElse?: () => void;
	waitForFiberOpticVideoChapter: () => string;
	notificationText?: string;
}

export interface GeneralNeutralStatePart7Config extends GeneralPartConfig {
	onPreOxygenated?: (selection: number) => void;
	onSettingUpAnythingElse?: () => void;
	waitForPreOxygenateVideoChapter: () => string;
}

export interface GeneralNeutralStatePart8Config extends GeneralPartConfig {
	onPatientFullyMedicated?: () => void;
	onSingleMedAdministered?: (med: GeneralNeutralStatePart8SingleMed) => void;
	onApneaStartedVideoChapter: () => string;
	
	meds: GeneralNeutralStatePart8SingleMed[];
}

export interface GeneralNeutralStatePart8SingleMed {
	title: string;
	audioPrefix: string;
}